<template>
  <div>
    <v-form ref="form" v-model="form.vaild">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-container fluid pa-0>
              <v-row justify="center">
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.data.title"
                    :counter="40"
                    label="名稱"
                    :rules="[rule.required, input => input.length < 40 || '超出字數限制']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-file-input
                    v-model="form.iconFile"
                    label="縮圖"
                    prepend-icon="mdi-camera"
                  ></v-file-input>
                  <!-- <a class="hover">
                    <v-img
                      class="hover"
                      width="100%"
                      max-width="120px"
                      src="https://fakeimg.pl/120/?text=上傳預覽圖"
                    ></v-img>
                  </a> -->
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.data.category"
              :items="categoryOptions"
              :rules="[rule.required]"
              item-text="text"
              item-value="value"
              label="類別"
              dense
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.data.outline"
              :counter="300"
              :rules="[input => input.length < 300 || '超出字數限制']"
              filled
              label="簡介"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.data.transcript"
              :counter="1000"
              :rules="[input => input.length < 1000 || '超出字數限制']"
              filled
              label="逐字稿"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <v-btn @click="submit()" :disabled="!form.vaild">建立</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { toDataUrl } from '@/lib/util'
import { createAlbum } from '@/lib/album'
export default {
  data(){
    return {
      rule: {
        required: (r) => (r && r.length > 0) || '該欄位為必填'
      },
      categoryOptions: [
        {
          text: '新聞',
          value: 'news'
        },
        {
          text: '搞笑',
          value: 'fun'
        }
      ],
      form: {
        vaild: false,
        data: {
          title: '',
          category: '',
          outline: '',
          transcript: '',
          owner: 'hAg8DqYaVnGJe5pX3TEuXJ' // TODO 之後要改掉 應該要從後端抓 session
        }
      }
    }
  },
  methods: {
    log(){},
    async submit(){
      if(this.$refs.form.validate()){
        let data = {
          ...this.form.data
        }
        try{
          if(this.form.iconFile){
            data.icon_url = await toDataUrl(this.form.iconFile)
          }else{
            data.icon_url = null
          }
          console.log(this.form.iconFile, data.icon_url)
          await createAlbum(data)
          this.$router.replace('/home/creator')
        }catch(e){
          console.error(e)
        }
      }
    }
  }
}
</script>

<style>
  .hover:hover{
    cursor: pointer;
    opacity: 0.7;
  }
</style>
